import { useState } from 'react'
import { useAtom } from 'jotai'
import { useAppCookies } from '@!/Hooks'
import { safeSearchAtom } from '@!/atoms/safeSearchAtom'
import { Flex, Box, Switch, VStack } from '@chakra-ui/react'

export const SafeSearch = () => {
  const { setSafeSearchCookie } = useAppCookies()
  const [safeSearch, setSafeSearch] = useAtom(safeSearchAtom)
  const [isEnabled, setIsEnabled] = useState(safeSearch)

  const handleToggle = (e) => {
    const newValue = e.checked
    setIsEnabled(newValue)
    setSafeSearch(newValue)
    setSafeSearchCookie(newValue)
    window.location.reload()
  }

  return (
    <VStack gap={0}>
      <Flex justifyContent="space-between" alignItems="center" width="100%">
        <Box fontSize="sm" fontWeight="semibold">
          セーフサーチ
        </Box>
        <Switch.Root size="lg" checked={isEnabled} onCheckedChange={handleToggle} colorPalette="green">
          <Switch.HiddenInput />
          <Switch.Control>
            <Switch.Thumb />
          </Switch.Control>
        </Switch.Root>
      </Flex>
    </VStack>
  )
}
